const VALID_MIME_TYPES = `image/*, application/pdf, application/msword, .psd, \
  text/*, application/vnd.ms-powerpoint, application/vnd.ms-excel`

class DocumentViewerController {
  constructor($rootScope, $scope, $http, Dropzone) {
    "ngInject"

    // This will prevent Dropzone to instantiate on it's own unless you are using
    // dropzone class for styling
    Dropzone.autoDiscover = false

    this.$http = $http
    this.$scope = $scope

    this.dzOptions = {}
    this.dzCallbacks = {}
    this.dzMethods = {}
    this.newFile = null

    this.documents = []
  }

  $onInit() {
    // console.log('url', this.documentApiUrl)
    this.initDropzone()

    this.getDocuments()
  }

  initDropzone() {
     // Dropzone options
     this.dzOptions = {
      url: `${this.documentApiUrl}/upload`,
      method: 'post',
      withCredentials: true,
      uploadMultiple: false,
      paramName: 'file', // name that will be used to transfer the file
      maxFilesize: '50000000', // in bytes
      // acceptedFiles: VALID_MIME_TYPES,  // Uncomment to restrict file types
      addRemoveLinks: true,
      clickable: true,
    }

    // Handle events for dropzone
    this.dzCallbacks = {
      'addedfile': (file) => {
        this.newFile = file
      },
      'success': (document, xhr) => {
        this.getDocuments()
      },
    }

    // Apply methods for dropzone
    this.dzMethods = {};
	  this.removeNewFile = () => {
      this.dzMethods.removeFile(this.newFile); //We got newFile from 'addedfile' event callback
    }
  }

  transformDocuments(documents)  {
     // Add helpful props on top of what we get from api
     return documents.map((doc) => Object.assign(doc, {
        sizeLabel: this.bytesToSize(doc.fileSize),
        url: `${this.documentApiUrl}/${doc.identifier}`,
      }))
      .reverse()
  }

  getDocuments() {
    this.$http.get(`${this.documentApiUrl}/list`, {withCredentials: true}).then((response) => {
        this.documents = this.transformDocuments(response.data || [])
        if (this.updatecount) {
          this.updatecount(this.documents.length)
        }
    }, (error) => {
      console.error('Error getting documents', error)
    })
  }

  deleteDocument(document) {
    this.$http.delete(`${this.documentApiUrl}/${document.identifier}`, {withCredentials: true})
      .then((response) => {
        this.getDocuments()
      }, (error) => {
        console.error('Error deleting document', error)
      })
  }

  bytesToSize(bytes, decimals = 2) {
    if (!Number(bytes)) {
      return '0 B'
    }

    const kbToBytes = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['B', 'KB', 'MB', 'GB']

    const index = Math.floor(Math.log(bytes) / Math.log(kbToBytes))

    return `${parseFloat(
      (bytes / Math.pow(kbToBytes, index)).toFixed(dm),
    )} ${sizes[index]}`
  }
}

export default DocumentViewerController



// WEBPACK FOOTER //
// ./client/common/document-viewer/document-viewer.controller.js